import React from 'react'
import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom'
import Perfil from '../pages/Perfil/Perfil'
import Default from '../templates/Default/Default'
import Home from '../pages/Home/Home'
import ErrorPage from '../templates/ErroPage/ErrorPage'
import Lojas from '../pages/Lojas/Lojas'
import PerguntasFrequentes from '../pages/Ajuda/PerguntasFrequentes'
import ComoUtilizarCupom from '../pages/Ajuda/ComoUtilizarUmCupom'
import QuemSomos from '../pages/Institucional/QuemSomos/QuemSomos'
import Imprensa from '../pages/Institucional/Imprensa/Imprensa'
import Contato from '../pages/Institucional/Contato/Contato'
import Categorias from '../pages/Categorias/Categorias'
import Jobs from '../pages/Institucional/TrabalheConosco/TrabalheConosco'
import Politica from '../pages/Institucional/Politica/Politica'
import Termos from '../pages/Institucional/Termos/Termos'
import MeuCupomDevolve from '../pages/MeuCupomDevolve/Devolve'
import TopCashback from '../pages/TopCashback/TopCashback'
import GoogleCallback from '../pages/GoogleCallback/GoogleCallback'
import HomeCupom from '../pages/HomeCupom/HomeCupom'
import TopTemplate from '../templates/TopCupons/TopCupons'
import DynamicRouteHandler from '../templates/Default/DinamicRouter'
import ClubeDoAluno from '../templates/ClubeDoAluno/ClubeDoAluno'
import RedefinirSenha from '../pages/RedefinirSenha/RedefinirSenha'


import RouteTracker from '../components/RouteTracker/RouteTracker'
import SeoByRoute from '../components/SeoByRoute/SeoByRoute'
import DataLayerBootstrap from '../components/DataLayerBootstrap/DataLayerBootstrap'

// UTMs padrão só entram se a URL de origem não trouxer as suas
// (assim gclid/utm_* de anúncios são preservados no redirect).
const withDefaultParams = (path, defaults) => (search) => {
  const params = new URLSearchParams(search);
  Object.entries(defaults).forEach(([key, value]) => {
    if (!params.has(key)) params.set(key, value);
  });
  return `${path}?${params.toString()}`;
};

const clubeAlunoRedirect = withDefaultParams("/hot-area-clube-do-aluno", { utm_source: "publisher", utm_campaign: "clubedoaluno" });
const clubeVantagensRedirect = withDefaultParams("/hot-area-clube-de-vantagens", { utm_source: "publisher", utm_campaign: "clube-de-vantagens" });
const promoveRedirect = withDefaultParams("/hot-area-promove", { utm_source: "publisher", utm_campaign: "promove" });

const ClubRedirect = ({ buildTo }) => {
  const { search } = useLocation();
  return <Navigate to={buildTo(search)} replace />;
};

// Links antigos usavam /top-cupons/cupom-desconto-todos[/:couponId]
const LegacyTopCuponsRedirect = () => {
  const { couponId } = useParams();
  const { search } = useLocation();
  const path = couponId ? `/top-cupons/${couponId}` : '/top-cupons';
  return <Navigate to={`${path}${search}`} replace />;
};

const Router = () => {
  return (
    <BrowserRouter>
        <RouteTracker />
        <DataLayerBootstrap />
        <SeoByRoute />
        <Routes>
            <Route path="/clubes" element={<Home />} />
            <Route path="/" element={<HomeCupom />} />
            <Route path="/ajuda/perguntas-frequentes" element={<PerguntasFrequentes/>}/>
            <Route path="/ajuda/como-utilizar-um-cupom" element={<ComoUtilizarCupom/>}/>
            <Route path="/institucional/quem-somos" element={<QuemSomos/>}/>
            <Route path="/institucional/imprensa" element={<Imprensa/>}/>
            <Route path="/institucional/contato" element={<Contato/>}/>
            <Route path="/institucional/termos-de-uso" element={<Termos/>}/>
            <Route path="/institucional/politica-de-privacidade" element={<Politica/>}/>
            <Route path="/jobs" element={<Jobs/>}/>
            <Route path="/lojas" element={<Lojas />} />
            <Route path="/categorias" element={<Categorias />} />
            <Route path="/devolve" element={<MeuCupomDevolve />} />
            <Route path="/top-cashback" element={<TopCashback />} />
            <Route path='/perfil/*' element={ <Perfil/> }/>
            <Route path="/auth/google/callback" element={<GoogleCallback />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />

            <Route
              path="/hot-area-estacio"
              element={<ClubRedirect buildTo={clubeAlunoRedirect} />}
            />

            <Route
              path="/estacio"
              element={<ClubRedirect buildTo={clubeAlunoRedirect} />}
            />

            <Route
              path="/clube-do-aluno"
              element={<ClubRedirect buildTo={clubeAlunoRedirect} />}
            />

            <Route
              path="/clube-de-vantagens"
              element={<ClubRedirect buildTo={clubeVantagensRedirect} />}
            />

            <Route
              path="/promove"
              element={<ClubRedirect buildTo={promoveRedirect} />}
            />

            <Route path="/hot-area-clube-do-aluno/:couponId?" element={<ClubeDoAluno slug="clube-do-aluno" />} />
            <Route path="/hot-area-clube-de-vantagens/:couponId?" element={<ClubeDoAluno slug="clube-de-vantagens" />} />
            <Route path="/top-cupons/cupom-desconto-todos/:couponId?" element={<LegacyTopCuponsRedirect />} />
            <Route path="/top-cupons/:couponId?" element={<TopTemplate/>} />


            <Route path="/:dynamicPath/:couponId?" element={<DynamicRouteHandler />} />
            <Route path="/not-found" element={<ErrorPage />} />
        </Routes>
    </BrowserRouter>
  )
}
export default Router